export default __webpack_public_path__ + "static/media/hero-nasdaq.7c118955.webp";